import { __decorate, __metadata, __param } from 'tslib';
import { Service } from '../../decorators/class/service.js';
import { StateManager } from '../store/state-manager.js';
import { BuiltinUiState } from '../store/builtin-state.js';
import { WorkbenchConfigurationState } from '../settings/auto-sync-settings.js';
import { IBadgeService } from './badge-service.interface.js';
import { LocalPersistStorage, BadgeService as BadgeService$1 } from '@tencent/docs-badge-service';
import { EventEmitter } from '../event-emitter/event-emitter.js';
import { Metadata } from '@tencent/workbench-core';
import { ServiceCollection } from '../service-collection.js';
import { ServiceNames } from '../../constants/service-name.js';
import { Inject } from '@tencent/ioc';
import { InternalEventEmitter } from '../event-emitter/internal-event-emitter.js';
import { InternalEvent } from '../event-emitter/internal-event.js';

Service()(LocalPersistStorage);
Metadata.set('design:paramtypes', [LocalPersistStorage], BadgeService$1);
Service({ provide: BadgeService$1 })(BadgeService$1);
/**
 * 工作台全局红点通知服务
 *
 * @public
 */
let BadgeService = class BadgeService {
    constructor(store, eventEmitter, badgeController, internalEventEmitter) {
        this.store = store;
        this.eventEmitter = eventEmitter;
        this.badgeController = badgeController;
        this.internalEventEmitter = internalEventEmitter;
        this.autoRelate = true;
        store.register(BuiltinUiState.Badge, []);
        this.badgeController.subscribe(this.update.bind(this));
        this.registerSchemaChangeListener();
    }
    clear() {
        this.badgeController.clear();
    }
    // 打开红点
    showBadgeOn(type, options) {
        this.badgeController.setPrefix(this.getPrefix());
        const badge = this.badgeController.showBadgeOn(type, options);
        if (this.autoRelate) {
            this.relate(badge);
        }
        this.eventEmitter.emit('$badge', { position: type, options });
        return badge;
    }
    // 关闭红点
    removeBadgeOn(type, key) {
        this.badgeController.removeBadgeOn(type, key);
    }
    /**
     * 计算红点之间的关系
     * @internal
     */
    updateRelation(type) {
        if (this.autoRelate) {
            this.badgeController.getMainBadges().forEach((badge) => {
                if (badge.info.position === type) {
                    this.relate(badge);
                }
            });
        }
    }
    /**
     * 返回指定位置上的红点
     * @internal
     */
    getBadgesOn(position, key) {
        if (key === undefined)
            return this.badgeController.getBadgesOn(position);
        return this.badgeController.getBadgesOn(position, key);
    }
    /**
     * 查询特定位置上是否存在红点
     *
     * @param position - 位置类型
     * @param key - 红点标识
     */
    hasBadgesOn(position, key) {
        return this.badgeController.hasBadgesOn(position, key);
    }
    registerSchemaChangeListener() {
        this.internalEventEmitter.listen(InternalEvent.SchemaRead, (position) => {
            const badgePosition = this.serviceNameToBadgePosition(position);
            if (!badgePosition) {
                return;
            }
            this.updateRelation(badgePosition);
        });
    }
    serviceNameToBadgePosition(position) {
        let badgePosition = undefined;
        if (position === ServiceNames.MENU) {
            badgePosition = 'menu';
        }
        if (position === ServiceNames.CONTEXT_MENU) {
            badgePosition = 'contextMenu';
        }
        if (position === ServiceNames.TOOLBAR) {
            badgePosition = 'toolbar';
        }
        if (position === ServiceNames.MOBILE_TOOLBAR) {
            badgePosition = 'mobileToolbar';
        }
        if (position === ServiceNames.MOBILE_MENU) {
            badgePosition = 'mobileMenu';
        }
        if (position === ServiceNames.MOBILE_CONTEXT_MENU) {
            badgePosition = 'mobileContextMenu';
        }
        if (position === ServiceNames.STATUSBAR) {
            badgePosition = 'statusbar';
        }
        return badgePosition;
    }
    getPrefix() {
        var _a;
        return (_a = this.store.getValue(WorkbenchConfigurationState.Namespace)) !== null && _a !== void 0 ? _a : '';
    }
    relate(badge) {
        var _a, _b, _c;
        const { info } = badge;
        if (info.position === 'menu') {
            const menuBadges = (_a = this.serviceCollection.get(ServiceNames.MENU)) === null || _a === void 0 ? void 0 : _a.path(info.key, 'root');
            menuBadges === null || menuBadges === void 0 ? void 0 : menuBadges.forEach((key) => {
                badge.relatedTo('menu', key);
            });
            return;
        }
        if (info.position === 'mobileMenu') {
            const mobileMenuBadges = (_b = this.serviceCollection.get(ServiceNames.MOBILE_MENU)) === null || _b === void 0 ? void 0 : _b.path(info.key, 'root');
            mobileMenuBadges === null || mobileMenuBadges === void 0 ? void 0 : mobileMenuBadges.forEach((key) => {
                badge.relatedTo('mobileMenu', key);
            });
            return;
        }
        if (info.position === 'contextMenu') {
            const menuBadges = (_c = this.serviceCollection.get(ServiceNames.CONTEXT_MENU)) === null || _c === void 0 ? void 0 : _c.path(info.key, 'root');
            menuBadges === null || menuBadges === void 0 ? void 0 : menuBadges.forEach((key) => {
                badge.relatedTo('contextMenu', key);
            });
            return;
        }
    }
    update(badges) {
        this.store.update(BuiltinUiState.Badge, badges);
    }
};
__decorate([
    Inject(),
    __metadata("design:type", ServiceCollection)
], BadgeService.prototype, "serviceCollection", void 0);
BadgeService = __decorate([
    Service({ overridable: true, provide: IBadgeService }),
    __param(3, Inject(InternalEventEmitter)),
    __metadata("design:paramtypes", [StateManager,
        EventEmitter,
        BadgeService$1,
        EventEmitter])
], BadgeService);

export { BadgeService };
//# sourceMappingURL=badge-service.js.map
